import * as yup from 'yup';
import { SEARCH_FILTER_KEYS } from 'v2/models';

const filterValueSchema = (name: string) =>
  yup.string().test({
    name,
    test: (value) => {
      return !Number.isNaN(+(value || ''));
    },
    message: 'Invalid value',
  });

const filterUnitSchema = () =>
  yup.string().when('value', {
    is: (data: string) => {
      return !!data;
    },
    then: (schema) => schema.required(),
  });

export const FiltersStepSchema = yup
  .object()
  .shape({
    filters: yup.object().shape({
      [SEARCH_FILTER_KEYS.data_lag]: yup.object().shape({
        unit: filterUnitSchema(),
        value: filterValueSchema(SEARCH_FILTER_KEYS.data_lag),
      }),
      [SEARCH_FILTER_KEYS.price]: yup.object().shape({
        unit: filterUnitSchema(),
        value: filterValueSchema(SEARCH_FILTER_KEYS.price).when(
          '$isFreeUser',
          (isFreeUser, schema) =>
            !isFreeUser
              ? schema
              : schema.test({
                  name: 'Maximun price required',
                  test: (value: string | undefined) => {
                    return value ? +value > 0 : false;
                  },
                  message: 'Maximun price required',
                })
        ),
      }),
      [SEARCH_FILTER_KEYS.history]: yup.object().shape({
        unit: filterUnitSchema(),
        value: filterValueSchema(SEARCH_FILTER_KEYS.history),
      }),
    }),
    extended: yup.boolean(),
    expires_at: yup.string(),
    expiration_method: yup.string(),
  })
  .test(
    'extendedRequestExpiresAt',
    'Please select a date in the future',
    (values) => {
      if (values.extended && values.expiration_method === 'date') {
        return (
          !!values.expires_at &&
          new Date(values.expires_at).getTime() > Date.now()
        );
      }
      return true;
    }
  );
